import { HashRouter, Routes, Route } from "react-router-dom";
import TofuApp from "./TofuApp";
import BetaInterest from "./BetaInterest";
import InviteRedeem from "./InviteRedeem";
import Feedback from "./feedback";

export default function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<TofuApp />} />
        <Route path="/beta" element={<BetaInterest />} />
        <Route path="/invite" element={<InviteRedeem />} />
        <Route path="/feedback" element={<Feedback />} />
      </Routes>
    </HashRouter>
  );
}
